import { useRef } from "react";
import Button from "./Button/Button";
import sendIcon from "./images/Send.png";
import axios from "axios";
import { useGlobalContext } from "../../../Context/Context";

const AddForm = ({
  addingDocument,
  setAddingDocument,
  setNewFiles,
  setAddingChecked,
  location,
}) => {
  const titleRef = useRef();
  const textRef = useRef();

  const { baseUrl } = useGlobalContext();
  const { apiKey, loggedUser } = useGlobalContext();

  console.log(addingDocument);

  const handleAdd = async () => {
    try {
      const { data } = await axios.post(
        `${baseUrl}/location_documents/createPendingDocument.php`,
        {
          user_id: loggedUser.id,
          api_key: apiKey,
          type: addingDocument.type,
          size: addingDocument.size,
          data: addingDocument.data,
          date: new Date(),
          title: titleRef.current.value,
          location_id: location.location_id,
          text: textRef.current.value,
        }
      );

      console.log(data);
      if (data.status === 200) {
        const newDocument = {
          ...addingDocument,
          title: titleRef.current.value,
          text: textRef.current.value,
        };
        setNewFiles((prev) => [...prev, newDocument]);
        setAddingDocument(undefined);
        setAddingChecked(false);
      }
    } catch (error) {
      console.log(error);
      setAddingChecked(false);
    }
  };

  return (
    <>
      <div className="update-form">
        <textarea
          ref={titleRef}
          className="update-form-input"
          rows={2}
          defaultValue={addingDocument.title}
        />
        <div className="update-form-btn" onClick={handleAdd}>
          <Button image={sendIcon} />
        </div>
        <input
          ref={textRef}
          className="update-form-text"
          defaultValue={addingDocument.text}
        />
      </div>
    </>
  );
};

export default AddForm;
